import React from 'react';
import { FEATURE_FLAGS } from '../../../engine/scoring/enhancedProfile';
import { getScoringCapabilities } from '../../../engine/scoring';

const ScoringToggle = ({ className = "" }) => {
  const capabilities = getScoringCapabilities();
  
  return (
    <div className={`bg-white rounded-lg shadow-sm border p-4 ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-medium text-gray-900">Scoring Engine</h4>
        <div className={`px-2 py-1 rounded text-xs font-medium ${
          FEATURE_FLAGS.ADVANCED_SCORING 
            ? 'bg-purple-100 text-purple-800' 
            : 'bg-gray-100 text-gray-800'
        }`}>
          v{capabilities.version}
        </div>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Basic Scoring</span>
          <span className="text-green-600">✓</span>
        </div>
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Enhanced Analytics</span>
          <span className={capabilities.enhanced ? 'text-green-600' : 'text-gray-400'}>
            {capabilities.enhanced ? '✓' : '○'}
          </span>
        </div>
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Cross-Dimensional</span>
          <span className={capabilities.crossDimensional ? 'text-green-600' : 'text-gray-400'}>
            {capabilities.crossDimensional ? '✓' : '○'}
          </span>
        </div>
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Confidence Intervals</span>
          <span className={capabilities.confidenceIntervals ? 'text-green-600' : 'text-gray-400'}>
            {capabilities.confidenceIntervals ? '✓' : '○'}
          </span>
        </div>
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Development Paths</span>
          <span className={capabilities.developmentPaths ? 'text-green-600' : 'text-gray-400'}>
            {capabilities.developmentPaths ? '✓' : '○'}
          </span>
        </div>
      </div>
      
      {FEATURE_FLAGS.ADVANCED_SCORING && (
        <div className="mt-3 pt-3 border-t">
          <div className="flex items-center space-x-2">
            <span className="text-purple-600">🧠</span>
            <span className="text-xs text-purple-700">Advanced scoring active</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoringToggle;